import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { registerApplication } from 'single-spa';

//TEMPORAL
import { getUserService } from './app/services/UserService';
import { initializeGTM } from './app/services/GTM';
import { getInformationMessagesService } from './app/services/InformationMessagesService';
import { getTermsConditions } from './app/services/TermsConditionsService';
import { fetchQualification } from './app/services/VirtualAccountService';

const GTM = 'GTM-PWLD9T7';
initializeGTM(GTM);

const interestBearingBlackList = (
  window.env?.REACT_APP_INTEREST_BEARING_BLACK_LIST || ''
)
  .split(',')
  .map((cuit) => cuit.trim())
  .filter((cuit) => cuit.length > 0);

const microfronts = [
  {
    name: 'menu',
    app: '@prisma/menu',
    activeWhen: '/',
  },
  {
    name: 'header',
    app: '@prisma/header',
    activeWhen: '/',
  },
  {
    name: 'liquidation',
    app: '@prisma/liquidation',
    activeWhen: '/liquidaciones',
  },
  {
    name: 'online-transfers',
    app: '@prisma/online-transfers',
    activeWhen: '/qr-transferencias/diarias',
  },
  {
    name: 'transaction',
    app: '@prisma/transaction',
    activeWhen: '/movimientos',
  },
  {
    name: 'ecommerce',
    app: '@prisma/ecommerce',
    activeWhen: '/venta',
  },
  {
    name: 'installment-plans',
    app: '@prisma/installment-plans',
    activeWhen: '/cuotas-mipyme',
  },
  {
    name: 'rejection',
    app: '@prisma/rejection',
    activeWhen: '/rechazos',
  },
  {
    name: 'early',
    app: '@prisma/early-payment',
    activeWhen: '/cobro-anticipado',
  },
  {
    name: 'movement-premium',
    app: '@prisma/transaction-premium',
    activeWhen: '/premium/movimientos',
  },
  {
    name: 'report-premium',
    app: '@prisma/report-premium',
    activeWhen: '/premium/reportes',
  },
  {
    name: 'liquidation-premium',
    app: '@prisma/liquidation-premium',
    activeWhen: '/premium/liquidaciones',
  },
  {
    name: 'conciliation-premium',
    app: '@prisma/conciliation-premium',
    activeWhen: ['/premium/conciliacion', '/ventas-online'],
  },
  {
    name: 'collaborator',
    app: '@prisma/collaborator',
    activeWhen: '/colaboradores',
  },
  {
    name: 'lending',
    app: '@prisma/lending',
    activeWhen: '/prestamos',
  },
  {
    name: 'anses',
    app: '@prisma/anses',
    activeWhen: '/anses',
  },
  {
    name: 'terminal',
    app: '@prisma/terminal',
    activeWhen: '/terminales',
  },
  {
    name: 'profile',
    app: '@prisma/profile',
    activeWhen: '/perfil',
  },
  {
    name: 'establishment',
    app: '@prisma/establishment',
    activeWhen: '/establecimientos',
  },
  {
    name: 'automatic-debit',
    app: '@prisma/automatic-debit',
    activeWhen: '/debito-automatico',
  },
  {
    name: 'certificate',
    app: '@prisma/certificate',
    activeWhen: '/certificados',
  },
  {
    name: 'upgrade',
    app: '@prisma/upgrade',
    activeWhen: '/mi-payway-profesional',
  },
  {
    name: 'inicio',
    app: '@prisma/home',
    activeWhen: '/inicio',
  },
  {
    name: 'ui-virtual-account',
    app: '@prisma/ui-virtual-account',
    activeWhen: '/mi-dinero',
  },
  {
    name: 'ui-virtual-account-landing',
    app: '@prisma/ui-virtual-account-landing',
    activeWhen: '/activar-cuenta-payway',
  },
  {
    name: 'ui-account-transfers',
    app: '@prisma/ui-account-transfers',
    activeWhen: '/transferencias',
  },
  {
    name: 'calendar',
    app: '@prisma/calendar',
    activeWhen: '/calendario',
  },
  {
    name: 'agreement',
    app: '@prisma/agreement',
    activeWhen: '/cuotas-payway',
  },
  {
    name: 'income',
    app: '@prisma/ui-income',
    activeWhen: '/cobros',
  },
  {
    name: 'mi-configuration',
    app: '@prisma/mi-configuration',
    activeWhen: '/mi-configuracion',
  },
  {
    name: 'ui-establishment',
    app: '@prisma/ui-establishment',
    activeWhen: '/productos-servicios',
  },
];

let virtualAccountStatus = null;
let virtualAccountData = null;

window.addEventListener('virtualAccountStatusUpdated', async () => {
  try {
    const { data: qualification } = await fetchQualification();
    virtualAccountStatus = qualification?.status ?? null;
    virtualAccountData = qualification ?? null;
  } catch (error) {
    console.error('Error refreshing virtual account status:', error);
  }
});

const configureMicrofronts = ({
  userRoles,
  informationMessagesMF = [],
  permissions,
  cuit,
  termsConditions = true,
  userData = null,
}) => {
  microfronts.map((config) =>
    registerApplication({
      ...config,
      app: () => window.System.import(config.app),
      customProps: () => {
        const informationMessages = informationMessagesMF.filter(
          (e) => e.name === config.name
        );
        return {
          userData,
          userRoles,
          informationMessages,
          permissions,
          cuit,
          termsConditions,
          virtualAccountStatus,
          virtualAccountData,
          interestBearingBlackList,
          analytics: {
            GTM,
          },
        };
      },
    })
  );
};

getUserService()
  .then(async ({ data: user }) => {
    const { roles, permissions, cuit, ...userData } = user;
    const { data: informationMessages } = await getInformationMessagesService();
    const { data: termsConditions } = await getTermsConditions(roles);

    if (roles.includes('ROLE_admin')) {
      try {
        const { data: qualification } = await fetchQualification();
        virtualAccountStatus = qualification?.status ?? null;
        virtualAccountData = qualification ?? null;
      } catch (error) {
        console.error('Error fetching virtual account status:', error);
      }
    }

    configureMicrofronts({
      userRoles: roles,
      informationMessagesMF: informationMessages,
      permissions,
      cuit,
      termsConditions,
      userData: Object.freeze({ cuit, ...userData }),
    });

    ReactDOM.render(
      <React.StrictMode>
        <App
          user={{ ...user, termsConditions }}
          getVirtualAccountStatus={() => virtualAccountStatus}
        />
      </React.StrictMode>,
      document.getElementById('root')
    );
  })
  .catch((error) => {
    const loginUrl = '/ms/ui-login/login';
    if (window.location.pathname !== loginUrl) {
      window.location = loginUrl;
    }
  });
